<div class="btn-wrapper" [ngStyle]="{'margin-bottom': mb, 'margin-top': mt}">
    <button class="secondary-btn" [ngClass]="{'destructive': destructive, 'action-panel': variant === 'action-panel'}">
        <ng-content></ng-content>
    </button>
</div>
